import { createStore } from 'zustand/vanilla';
import { useStore } from 'zustand';

interface TooltipStore {
    tooltipText: string | null;
    setTooltipText: (text: string) => void;
}

const tooltipStore = createStore<TooltipStore>((set) => ({
    tooltipText: null,
    setTooltipText: (text) => set({ tooltipText: text }),
}));

export const setTooltipText = (text: string) => tooltipStore.getState().setTooltipText(text);

export const useTooltipText = () => useStore(tooltipStore, (store) => store.tooltipText);
